module.exports = __webpack_public_path__ + "img/icon_3_19.34691fd0.png";